<template>
  <div class="navbar">
    <p><img class="logo_img" src="@/assets/images/logo.png" alt=""></p>
    <ul class="main">
      <li>
        <router-link to="/">
          <span class="navbar_icon"><HomeIcon></HomeIcon></span> <span class="navbar_item_text">Проекты</span>
        </router-link>
      </li>
      <li>
        <router-link to="/contractors">
          <span class="navbar_icon"><ProfileUsers></ProfileUsers></span> <span class="navbar_item_text">Контрагенты</span>
        </router-link>
      </li>
      <li>
        <router-link to="/employees">
          <span class="navbar_icon"><PersonalCard></PersonalCard></span> <span class="navbar_item_text">Сотрудники</span>
        </router-link>
      </li>
      <li>
        <router-link to="/inventory">
          <span class="navbar_icon"><RulerPen></RulerPen></span> <span class="navbar_item_text">Инвентарь</span>
        </router-link>
      </li>
      <li>
        <router-link to="/library">
          <span class="navbar_icon"><BookIcon></BookIcon></span> <span class="navbar_item_text">Справочник</span>
        </router-link>
      </li>
<!--      <li>-->
<!--        <router-link to="/sklad">-->
<!--          <span class="navbar_icon"><SkladIcon></SkladIcon></span> <span class="navbar_item_text">Склад</span>-->
<!--        </router-link>-->
<!--      </li>-->
    </ul>
    <div class="avatar">
      <div class="avatarimg__wrapper">
        <img @click="handleNavAvatar" :src="$store.getters.avatar" />
        <div class="avatarimg__icons">
          <router-link to="/settings"><SettingsIcon class="setting_icon"></SettingsIcon></router-link>
          <LoginIcon @click="logout"></LoginIcon>
        </div>
      </div>
<!--      <ul>-->
<!--        <li>-->
<!--          <router-link to="/settings" class="btn-floating grey">-->
<!--            <i class="material-icons-outlined">settings</i>-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a class="btn-floating grey" @click="logout">-->
<!--            <i class="material-icons-outlined">logout</i>-->
<!--          </a>-->
<!--        </li>-->
<!--      </ul>-->
    </div>
    <!-- <div class="topbar" v-if="$route.name == 'Documents'" :class="open"></div> -->
    <div class="topbar" :class="{ open: isTopbar }">
      <ul class="project">
        <li class="project-name">{{ $store.c }}</li>
        <li>
          <router-link
            :to="{
              name: 'Estimate',
              params: { projectId: $route.params.projectId || 0 },
            }"
          >
            <i class="material-icons-outlined">receipt_long</i>
            <span class="project-division-name">Смета</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{
              name: 'Documents',
              params: { projectId: $route.params.projectId || 0 },
            }"
          >
            <i class="material-icons-outlined">description</i>
            <span class="project-division-name">Документы</span>
          </router-link>
        </li>
<!--        <li>-->
<!--          <router-link-->
<!--            :to="{-->
<!--              name: 'Warehouse',-->
<!--              params: { projectId: $route.params.projectId || 0 },-->
<!--            }"-->
<!--          >-->
<!--            <i class="material-icons-outlined">inventory_2</i>-->
<!--            <span class="project-division-name">Склад</span>-->
<!--          </router-link>-->
<!--        </li>-->
      </ul>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";
import HomeIcon from "@/components/Icons/HomeIcon";
import BookIcon from "@/components/Icons/BookIcon";
import PersonalCard from "@/components/Icons/PersonalCard";
import ProfileUsers from "@/components/Icons/ProfileUsers";
import RulerPen from "@/components/Icons/RulerPen";
import SettingsIcon from "@/components/Icons/SettingsIcon";
import LoginIcon from "@/components/Icons/LoginIcon";
// import SkladIcon from "@/components/Icons/SkladIcon";

export default {
  name: "Navbar",
  data: () => {
    return {
      avatar: "",
    };
  },
  components: {
    HomeIcon,
    BookIcon,
    PersonalCard,
    ProfileUsers,
    RulerPen,
    SettingsIcon,
    LoginIcon,
    // SkladIcon,
  },
  async mounted() {
    const fixed = document.querySelectorAll(".avatar");
    M.FloatingActionButton.init(fixed, { direction: "top" });
    this.$store.dispatch("getAvatar");
  },
  computed: {
    isTopbar() {
      if (["Documents", "Estimate", "Warehouse"].includes(this.$route.name)) {
        return true;
      }
      return false;
    },
    currentRouteName() {
      return this.$route.name;
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("isLogged");
      this.$router.replace("/login");
    },
    handleNavAvatar() {
      if (document.querySelector(".avatarimg__icons").style.display === "flex") {
        document.querySelector(".avatarimg__icons").style.display = "none";
      }
      else {
        document.querySelector(".avatarimg__icons").style.display = "flex";
      }

    }
  },
};
</script>
<style lang="stylus" scoped>


</style>
